import { useQuery } from '@tanstack/react-query';
import { PixelService } from '@/services/pixels.service.ts';

interface UsePixelProps {
    productId: string;
    pixelId: string;
}

export function usePixel({ productId, pixelId }: UsePixelProps) {
    const { data: pixel, isLoading } = useQuery({
        queryKey: ['pixel', productId, pixelId],
        queryFn: () => PixelService.viewPixel({ productId, pixelId })
    });

    return {
        pixel,
        isLoading
    };
}